// src/app/weather-widget/parts/weather-header.component.ts
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { UserLocation } from '../../../../../models/location.model';
import { iconConfig, getWeatherTranslationKey } from '../../models/weather.model';
import { WeatherSettingsService } from '../../services/weather-settings.service';
import { WeatherStore } from '../../services/weather.store';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { TranslateModule } from '@ngx-translate/core';
import { MixPanelEvent, MixPanelService } from '@/app/services/mixpanel.service';

@Component({
  selector: 'dr-flex-home-ui-weather-top',
  standalone: true,
  imports: [CommonModule, SearchResultsComponent, TranslateModule],
  templateUrl: './weather-top.component.html',
  styleUrls: ['./weather-top.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherTopComponent {
  store = inject(WeatherStore);
  temp = this.store.headerTemp;
  summary = this.store.headerSummary;
  unit = this.store.unit;
  weatherSettings = inject(WeatherSettingsService);
  private readonly mixpanelService = inject(MixPanelService);

  condition = computed(() => {
    return getWeatherTranslationKey(this.summary());
  });

  iconConfig(summary: number | null) {
    return iconConfig(summary);
  }

  onLocationSelected(location: UserLocation) {
    this.mixpanelService.trackEvent(MixPanelEvent.ACTION_WEATHER_LOCATION, { location: location.name });
    this.store.setAndSaveLocation(location);
  }
}
